import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface ParkingState {
  totalRecords: number | null;
  data: [] | null;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: ParkingState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const parkingSlice = createSlice({
  name: 'parkings',
  initialState,
  reducers: {
    setParkings: (state, action) => {
      state.data = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setParkings, reset } = parkingSlice.actions;

// selectors
export const getParkingSpaces = (state: RootState) => state.parkings.data;
export const getParkingTotalRecords = (state: RootState) => state.parkings.totalRecords;
export const getParkingTotalPages = (state: RootState) => state.parkings.totalPages;
export const getActiveParkingSpaces = (state: RootState) => state.parkings.data;
// export const getInActiveParkingSpaces = (state: RootState) =>
//   state.parkings.data && state.parkings.data.filter((parking: any) => parking.currentStatus === 'pending');

export default parkingSlice.reducer;
